var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.4397 49.7946C17.2797 49.7946 11.9159 45.5887 10.4468 39.6064L39.457 39.6697C37.9946 45.6152 32.6627 49.7946 26.5399 49.7946H23.4397Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.4492 37.6195L9.59766 32.7903H40.3174L39.4525 37.6195H10.4492Z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.4859 22.273C24.4859 22.273 26.1369 19.3613 29.0273 16.382C29.0273 16.382 27.3863 4.26152 44.1516 5.48242C44.1516 5.48242 47.0723 5.66152 49.9043 4.88027C49.9043 4.88027 48.4111 8.70117 47.4102 11.8338C46.4092 14.9664 42.9189 21.666 31.2727 19.0521C31.2727 19.0521 37.868 10.2756 45.1242 7.57793C45.1242 7.57793 32.049 11.8338 25.6432 24.865L27.0477 30.6928H23.8393C23.8393 30.6928 23.3377 14.7051 8.25039 4.29766C8.25039 4.29766 15.8082 11.508 18.8408 18.4535C18.8408 18.4535 7.64609 20.8725 3.72988 9.71328C3.72988 9.71328 1.26426 2.01699 1 0C1 0 8.36895 1.02266 11.7205 1.02266C15.0721 1.02266 28.035 2.74395 22.1734 17.2012L24.4859 22.273Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.06c2e6d0d35e54f3940012da904a9d12.svg";
export { ForwardRef as ReactComponent };